import React from 'react';
import { MessageCircle, FileText } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hola GONSO, quisiera cotizar productos/hortalizas para mi negocio");
    window.open(`https://wa.me/50488606154?text=${message}`, '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_gonso-produccion/artifacts/7fz0os7z_image.png"
          alt="Campo agrícola"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-3 leading-tight animate-in fade-in slide-in-from-bottom-10 duration-700" style={{ color: '#077c38' }}>
            GONSO
          </h1>
          <p className="text-2xl md:text-3xl lg:text-4xl text-white font-semibold mb-6 animate-in fade-in slide-in-from-bottom-10 duration-700 delay-100">
            Produciendo para Honduras
          </p>
          <p className="text-lg md:text-xl lg:text-2xl text-gray-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-10 duration-700 delay-150">
            Hortalizas frescas al por mayor. Abastecemos supermercados, distribuidores y el sector hotelero con productos de calidad, entregas puntuales y trazabilidad garantizada en todo Honduras.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-10 duration-700 delay-300">
            <Button
              size="lg"
              onClick={handleWhatsAppClick}
              className="bg-[#019645] hover:bg-[#077c38] text-white text-lg px-8 py-6 transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <MessageCircle className="mr-2" size={24} />
              Cotizar por WhatsApp
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={scrollToContact}
              className="border-2 border-white text-white hover:bg-white hover:text-[#019645] text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
            >
              <FileText className="mr-2" size={24} />
              Solicitar Cotización
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 120" className="w-full h-auto">
          <path
            fill="#ffffff"
            d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
          ></path>
        </svg>
      </div>
    </section>
  );
};
